const Errors = {
  REQUIRED_FIELD: 'The field is required',
  POSITIVE_NUMBER: 'Value must be a positive integer',
  VALID_EMAIL: 'Please enter a valid email',
  VALID_DATE: 'Must be a date in the correct "mm/dd/yyyy" format',
  VALID_PHONE: 'Please enter the correct phone number',
};

export default Errors;
